import { Divider, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { CartProductCode } from '@ace-clublabs/common-membership-api-types';
import { ReviewItem } from './ReviewItem';
import { useContext } from 'react';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';
import { ProductType } from '../../application/models/NewJoinSessionData';

export const ReviewAddOnSection = () => {
  const { sessionData } = useContext(MembershipAppStateContext);

  const CartProductCodeMap = {
    [ProductType.RV]: CartProductCode.RV,
    [ProductType.ERS]: CartProductCode.ERSFEE,
  };

  return (
    <Stack>
      <Stack direction="column" className="add-on-section-container" width="100%" gap="0.5rem">
        <Typography variant="b3Regular" className="add-on-section-title">
          Add-ons
        </Typography>
        {sessionData.formData.products?.map((product) => {
          const productPriceCart = sessionData.priceCart?.items?.find((a) => a.code === CartProductCodeMap[product]);
          return (
            <ReviewItem title={productPriceCart?.description!} {...productPriceCart!} className={`${product}-title`} />
          );
        })}
      </Stack>
      <Divider variant="fullWidth" sx={{ margin: '1rem 0' }} />
    </Stack>
  );
};
